import { autoFormat } from 'app-lib/numberUtils'
import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import ButtonChainSwitch from 'shared-components/ButtonChainSwitch'
import { Button } from 'ui-framework'
import CompensationVM from '../CompensationVM'

export function BZRXCompensationBSCStep1({ vm }: { vm: CompensationVM }) {
  const bzrxBalance = vm.rootStore.userWallet.indexedByAsset.BZRX
  const { chainId, isConnected } = vm.rootStore.web3Connection

  if (chainId !== 56) {
    return (
      <>
        <p className="txt-warning txt-center">
          You need to be on {chainConfigs[56].chainDetails.shortName} to send your BZRX.
        </p>
        <div className="flex-center">
          <ButtonChainSwitch chainId={56}>
            Switch to {chainConfigs[56].chainDetails.shortName}
          </ButtonChainSwitch>
        </div>
      </>
    )
  }

  return (
    <>
      <h4>Send your BZRX to our contract</h4>

      {bzrxBalance ? (
        <>
          {vm.bzrxSentToBscCompensationContract ? (
            <p>Tokens sent</p>
          ) : (
            <p>
              You have <b className="txt-positive">{autoFormat(bzrxBalance.amount)}</b> BZRX in your
              wallet.
            </p>
          )}

          <Button
            onClick={vm.sendBZRXtoBscCompensationContract}
            className="btn--responsive"
            variant="green"
            disabled={bzrxBalance.amount.isZero()}
            isLoading={vm.rootStore.userWallet.pending}>
            Send my BZRX
          </Button>
        </>
      ) : (
        <p>
          {isConnected ? (
            <i>Loading balance...</i>
          ) : (
            <span className="txt-warning">You need to connect your wallet.</span>
          )}
        </p>
      )}

      <div className="txt-explanation margin-top-2">
        <h4 className="h4">When will I get my airdrop?</h4>
        <p>
          We create a new airdrop every two weeks. After you send your BZRX, you should come back
          here in two weeks and you will be able to claim your airdrop on Polygon.
        </p>
      </div>
    </>
  )
}

export default observer(BZRXCompensationBSCStep1)
